import {
  type ServiceContent as ServiceContentType,
  type TextSegment,
} from "../data/types";

interface ServiceContentProps {
  content: ServiceContentType;
}

const TextSegment = ({ segment }: { segment: TextSegment }) => (
  <span
    className={`${
      segment.isBold ? "text-lg font-medium ph:text-xl" : "text-base ph:text-lg"
    }`}
  >
    {segment.text}
  </span>
);

const parseTextWithBold = (text: string) => {
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      const content = part.slice(2, -2);
      return (
        <span key={index} className="text-lg font-medium ph:text-xl">
          {content}
        </span>
      );
    }
    return <span key={index}>{part}</span>;
  });
};

export const ServiceContentComponent = ({ content }: ServiceContentProps) => {
  if (content.type === "list" && content.items) {
    return (
      <div className="flex flex-col gap-6">
        {content.segments && content.segments.length > 0 && (
          <p className="leading-relaxed">
            {content.segments.map((segment, index) => (
              <TextSegment key={index} segment={segment} />
            ))}
          </p>
        )}
        <ul className="flex flex-col gap-4">
          {content.items.map((item, index) => (
            <li key={index} className="flex items-start gap-4">
              <span className="mt-1.5 h-2 w-2 rounded-full bg-current"></span>
              <span className="flex-1 leading-relaxed">
                {parseTextWithBold(item)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <p className="leading-relaxed">
      {content.segments.map((segment, index) => (
        <TextSegment key={index} segment={segment} />
      ))}
    </p>
  );
};
